const NON_EMBEDDABLE_IMAGE_HOSTS = ['drive.google.com', 'docs.google.com']

/** URLs that browsers block from loading in img cross-origin (e.g. Google Drive viewer). */
export default function isEmbeddableImageUrl(url: string): boolean {
    if (!url.trim()) {
        return false
    }

    try {
        const parsed = new URL(url, window.location.origin)

        if (parsed.protocol === 'data:' || parsed.protocol === 'blob:') {
            return true
        }

        if (parsed.origin === window.location.origin) {
            return true
        }

        const hostname = parsed.hostname.toLowerCase()

        if (
            NON_EMBEDDABLE_IMAGE_HOSTS.some(
                host => hostname === host || hostname.endsWith(`.${host}`)
            )
        ) {
            return false
        }

        if (hostname.endsWith('google.com') && parsed.pathname.includes('drive')) {
            return false
        }

        return true
    } catch {
        return false
    }
}
